import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { IonLoading, useIonViewWillEnter } from '@ionic/react';
import { useParams } from 'react-router-dom';
import { PageLayout } from 'containers/layout';
import OrderActions, { OrderSelectors } from 'redux/OrderRedux';
import MenuItemDetail from 'containers/order/MenuItemDetail';

function ViewMenuItemDetail() {
  const params = useParams();
  const dispatch = useDispatch();
  const loading = useSelector(OrderSelectors.selectMenuItemsLoading);
  const { itemId, locationId: venueId } = params;
  const item = useSelector(OrderSelectors.selectMenuItem(venueId, itemId));

  useIonViewWillEnter(() => {
    dispatch(OrderActions.loadMenuItems(venueId));
  });

  return (
    <PageLayout back title={item && item.name}>
      <IonLoading isOpen={loading} message="Loading..." />
      {item && <MenuItemDetail item={item} />}
    </PageLayout>
  );
}

export default ViewMenuItemDetail;
